module.exports = __webpack_public_path__ + "img/swiper_6.37f223e5.jpg";